import React from "react";
import { Wand as WandIcon } from "@/components/ds/icons";

/**
 * Standard "Launch Starter Wizard" button — use this everywhere a StarterWorkflowWizard
 * can be launched. Keeps the style consistent across all integration and channel pages.
 *
 * Usage:
 *   <LaunchWizardButton onClick={() => setShowWizard(true)} />
 *   <LaunchWizardButton onClick={() => setShowWizard(true)} disabled={!hasConfig} />
 *   <LaunchWizardButton onClick={() => setShowWizard(true)} label="Set Up Workflows" />
 */
interface LaunchWizardButtonProps {
  onClick(): void;
  disabled?: boolean;
  label?: string;
  size?: "sm" | "md";
}

export default function LaunchWizardButton({
  onClick,
  disabled = false,
  label = "Launch Starter Wizard",
  size = "md",
}: LaunchWizardButtonProps) {
  const sizeClasses = size === "sm"
    ? "text-xs px-3 py-1.5"
    : "text-sm px-4 py-2";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${sizeClasses} bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap font-medium shadow-sm transition-colors flex items-center gap-1.5`}
    >
      <WandIcon className="w-3.5 h-3.5 opacity-80 inline-block align-middle" />
      {label}
    </button>
  );
}
